<template>
  <div class="vue-component-holder dashboard" v-if="data">
    <!-- Page -->
    <div class="page" v-if="!fullSize">
      <div class="page-content container-fluid">
        <div class="row">
          <div class="col-lg-12">
            <div class="grid-wrapper">
              <dashboard-grid-stack
                :data="data"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row row-scheduler row-kpi" v-if="fullSize">
      <div class="col-lg-12">
        <div class="panel-body">
          <dashboard-grid-stack
            :data="data"
            :customizeSizing="false"
            ref="gridStack"
          />
        </div>
      </div>
    </div>

    <scheduler
      v-if="scheduler"
      :menuField="scheduler"
      @dataRefreshed="schedulerDataRefreshed"
    />

    <my-footer></my-footer>

  </div>

</template>

<script>
import MyHeader           from '../layout-header'
import LeftMenu           from '../layout-left-menu'
import MyFooter           from '../layout-footer'
import DashboardGridStack from './../../widgets/DashboardGridStack'
import DependenciesLoader from '../../../model/loader/user-base-entities-loader'
import Scheduler          from '../sheduler/scheduler'

export default {
  components: {
    Scheduler,
    DashboardGridStack,
    LeftMenu,
    MyHeader,
    MyFooter
  },

  data () {
    return {
      timer:     null,
      data:      [],
      fullSize:  false,
      scheduler: null
    }
  },

  created () {
    DependenciesLoader.getDashboardData(
      (response, data) => {
        this.data = data.Fields
        this.data.map((item) => {
          if (item.Interpretation === 'Scheduler') {
            this.fullSize  = true
            this.scheduler = item
          }
        })
      },
      (error) => {
        this.handleApiError(error)
      })

    if (this.$store.getters.hpRedirect) {
      window.location.reload()
      this.$store.commit('setHpRedirect', false)
    }
  },

  mounted () {
    // this.timer = setTimeout(() => {
    //   window.location.reload()
    // }, 120000)
  },

  destroyed () {
    clearTimeout(this.timer)
  },

  methods: {
    schedulerDataRefreshed () {
      DependenciesLoader.getDashboardData(
        (response, data) => {
          this.data = data.Fields
          this.data.map((item) => {
            if (item.Interpretation === 'Scheduler') {
              this.fullSize  = true
              this.scheduler = item
            }
          })
        },
        (error) => {
          this.handleApiError(error)
        })
    }
  }
}
</script>
